import RandExp from 'randexp';

export const toISOLocal = (d: Date): string => {
  const z = (n: number) => `0${n}`.slice(-2);
  const zz = (n: number) => `00${n}`.slice(-3);
  let off = d.getTimezoneOffset();
  off = Math.abs(off);

  return `${d.getFullYear()}-${z(d.getMonth() + 1)}-${z(d.getDate())}T${z(
    d.getHours(),
  )}:${z(d.getMinutes())}:${z(d.getSeconds())}.${zz(d.getMilliseconds())}Z`;

};

export const generateId = (): string => {
  const regex = /^[a-fA-F0-9]{8}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{4}-[a-fA-F0-9]{12}$/;

  return new RandExp(regex).gen();
};

export const missionType = [
  'Comando',
  'Rota de Fiscalização',
  'Bloqueio',
  'Apoio semáforo',
  'Fiscalização Itinerante',
  'Reserva de vaga',
  'Volante',
  'Outros',
];

export const missionFocus = [
  'Geral',
  'Educativo',
  'Lei Seca',
  'Uso correto do Cinto de Segurança',
  'Uso correto do Capacete',
  'Estacionamento (Zona Azul)',
  'Esquina Segura',
  'Sucata (NVA)',
  'Sem veículo (SUV)',
  'AET',
  'Operacional',
  'Outro',
];

export const suportTeam: string[] = [
  'Polícia Rodoviária Federal (PRF)',
  'Guarda Municipal de Fortaleza (GMF)',
  'Polícia Militar',
  'Gerência de Educação no Trânsito',
  'Outro',
];
